/* MSW Free Shipping Bar — deferred external script */
(function() {
  'use strict';

  var STATE_KEY = 'msw_ship_state';
  /* Published after every run so other scripts (the cart drawer upsell) can react:
     { region: 'US'|'CA'|'INTL', currency, threshold (cents, null = no free-shipping offer), total (cents), remaining (cents, 0 when earned) } */
  function publish(state) {
    window.mswShipState = state;
    try { document.dispatchEvent(new CustomEvent('msw:shipping', { detail: state })); } catch (e) {}
  }
  function wrappers() { return document.querySelectorAll('.free-shipping-wrapper'); }
  function settle() { wrappers().forEach(function(w) { w.classList.remove('msw-shipping-pending'); }); }
  function saveState(msg, hidden, region) {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify({ msg: msg, hidden: !!hidden, region: region })); } catch (e) {}
  }
  // Paint the last known state immediately (before any network) so nothing flashes on navigation
  function applyCachedState() {
    var st = null;
    try { st = JSON.parse(sessionStorage.getItem(STATE_KEY) || 'null'); } catch (e) {}
    if (!st || !st.msg) return;
    document.querySelectorAll('#shipping-message').forEach(function(m) { m.innerHTML = st.msg; });
    wrappers().forEach(function(w) { w.classList.toggle('msw-bar-hidden', !!st.hidden); });
    if (st.region) window.mswGeoRegion = st.region;
    settle();
  }

  var inflight = false, queued = false;
  function updateFreeShippingBar() {
    if (inflight) { queued = true; return; }   // coalesce bursts into one follow-up run
    inflight = true;
    var done = function() { inflight = false; if (queued) { queued = false; setTimeout(updateFreeShippingBar, 150); } };
    fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        // Check sessionStorage cache first
        var cached = null;
        try { cached = sessionStorage.getItem('msw_geo_iso'); } catch(e) {}

        if (cached) {
          applyShippingLogic(cached, cart);
        } else {
          fetch('https://get.geojs.io/v1/ip/country.json')
            .then(function(res) { return res.json(); })
            .then(function(data) {
              var isoCode = data.country;
              try { sessionStorage.setItem('msw_geo_iso', isoCode); } catch(e) {}
              applyShippingLogic(isoCode, cart);
            })
            .catch(function(err) {
              console.error("GeoIP Failed, defaulting to International logic.", err);
              applyShippingLogic(null, cart);
            });
        }
      })
      .catch(function(err) { console.error('Error loading cart:', err); settle(); })
      .finally(done);
  }

  function applyShippingLogic(isoCode, cart) {
    var cleanIso = isoCode ? isoCode.trim().toUpperCase() : '';
    var isCanada = cleanIso === 'CA';
    var isUS = cleanIso === 'US';

    // Expose region globally for other scripts
    window.mswGeoRegion = isUS ? 'US' : isCanada ? 'CA' : 'INTL';

    var fills = document.querySelectorAll('.shipping-bar-fill');
    var messages = document.querySelectorAll('#shipping-message');
    var containers = document.querySelectorAll('.shipping-bar-container');

    // === INTERNATIONAL (NOT US OR CA) ===
    if (!isCanada && !isUS) {
      containers.forEach(function(el) {
        el.style.display = 'none';
        el.style.visibility = 'hidden';
        var wrap = el.closest('.free-shipping-wrapper') || el.parentElement; if (wrap) wrap.classList.add('msw-bar-hidden');
      });
      messages.forEach(function(msg) {
        msg.style.display = 'block';
        msg.style.visibility = 'visible';
        if (msg.parentElement) msg.parentElement.style.display = 'block';
        msg.innerHTML = "Local Duties included in Shipping Rates";
      });
      saveState("Local Duties included in Shipping Rates", true, 'INTL'); settle();
      applyUpsellRegion('INTL');
      publish({ region: 'INTL', currency: String(cart.currency || ''), threshold: null, total: cart.total_price, remaining: null });
      return;
    }

    // === US / CANADA: free-shipping threshold ===
    // cart.total_price is in the shopper's *presentment* currency, so the threshold and the
    // formatting must follow the cart currency — not the geo region.
    var region = isUS ? 'US' : 'CA';
    var currency = String(cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD').toUpperCase();
    var THRESHOLDS = { USD: 5000, CAD: 10000 };   // cents, per currency
    var threshold = THRESHOLDS[currency];
    var total = cart.total_price;

    // Locale pinned to "en" so the symbol is stable everywhere: USD → "$50", CAD → "CA$100" (matches the rest of the site)
    var fmtWhole, fmtCents;
    try {
      fmtWhole = new Intl.NumberFormat('en', { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
      fmtCents = new Intl.NumberFormat('en', { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      fmtWhole = fmtCents = { format: function(n) { return currency + ' ' + n.toFixed(2); } };
    }
    function money(cents) {
      var n = cents / 100;
      return (n % 1 === 0) ? fmtWhole.format(n) : fmtCents.format(n);
    }

    if (!threshold) {
      // Viewing in a currency other than USD/CAD = international market, regardless of geo → same message as INTL
      containers.forEach(function(el) { el.style.display = 'none'; el.style.visibility = 'hidden'; var wrap = el.closest('.free-shipping-wrapper') || el.parentElement; if (wrap) wrap.classList.add('msw-bar-hidden'); });
      messages.forEach(function(msg) {
        msg.style.display = 'block';
        msg.style.visibility = 'visible';
        if (msg.parentElement) msg.parentElement.style.display = 'block';
        msg.innerHTML = "Local Duties included in Shipping Rates";
      });
      window.mswGeoRegion = 'INTL';
      saveState("Local Duties included in Shipping Rates", true, 'INTL'); settle();
      applyUpsellRegion('INTL');
      publish({ region: 'INTL', currency: currency, threshold: null, total: total, remaining: null });
      return;
    }

    var percentage = Math.min((total / threshold) * 100, 100);
    var cartEmpty = !cart.item_count;
    containers.forEach(function(el) {
      el.style.display = 'block';
      el.style.visibility = 'visible';
      if (el.parentElement) el.parentElement.style.display = 'block';
      // Empty cart: collapse the bar (CSS transition) and leave just the threshold line; it pops open on the first add
      var wrap = el.closest('.free-shipping-wrapper') || el.parentElement;
      if (wrap) wrap.classList.toggle('msw-bar-hidden', cartEmpty);
    });
    fills.forEach(function(fill) { fill.style.width = percentage + '%'; });

    var text = cartEmpty ? 'Free Shipping on Orders ' + money(threshold) + '+'
             : (total >= threshold ? "You've earned FREE shipping!" : 'Only ' + money(threshold - total) + ' away from Free Shipping');
    messages.forEach(function(msg) {
      msg.style.display = 'block';
      msg.style.visibility = 'visible';
      if (msg.parentElement) msg.parentElement.style.display = 'block';
      msg.innerHTML = text;
    });
    saveState(text, cartEmpty, region); settle();

    applyUpsellRegion(region, money(threshold));
    publish({ region: region, currency: currency, threshold: threshold, total: total, remaining: Math.max(0, threshold - total) });
  }

  // Region-dependent copy outside the bar itself
  function applyUpsellRegion(region, thresholdText) {
    // Any ".msw-us-only" copy shows for US only
    document.querySelectorAll('.msw-us-only').forEach(function(el) { el.style.display = region === 'US' ? '' : 'none'; });

    // Product-page perk tile: lead with the free-shipping threshold where one exists
    var perkText = (thresholdText && (region === 'US' || region === 'CA'))
                 ? 'Free Shipping<br>on ' + thresholdText + '+'
                 : 'Ships in<br>24-48 hrs';
    document.querySelectorAll('.msw-perk-shipping').forEach(function(el) { el.innerHTML = perkText; });
  }

  // Expose globally so other scripts can trigger updates
  window.updateFreeShippingBar = updateFreeShippingBar;

  // Paint cached state now (script is deferred: DOM is parsed, usually before first paint), then refresh from the network
  applyCachedState();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateFreeShippingBar); else updateFreeShippingBar();

  // PubSub Listener (Shopify Standard)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      setTimeout(updateFreeShippingBar, 100);
    });
  }

  // (The old MutationObserver on <cart-drawer> is gone: it re-ran this on every attribute change — including our own
  //  class toggles — which looped. Every cart path calls updateFreeShippingBar() explicitly: cart-drawer.js renderContents,
  //  the drawer's refresh(), free-gift.js, and the Shopify cartUpdate pub/sub above.)
})();
